import { getEquipmentDetailRequest } from '../../services/equipment';
import { EQUIPMENT_DETAIL_CACHE_KEY } from '../../services/queryKeys';
import { useAxiosQuery } from '../useAxiosQuery';
import { Equipment } from './types';

interface UseGetEquipmentDetailsReturn {
  equipment: Equipment | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useGetEquipmentDetails(equipmentId: string): UseGetEquipmentDetailsReturn {
  const {
    data: equipment,
    isLoading,
    error,
    refetch,
  } = useAxiosQuery<Equipment>(EQUIPMENT_DETAIL_CACHE_KEY(equipmentId), getEquipmentDetailRequest(equipmentId).path, {
    enabled: !!equipmentId,
    retry: (failureCount, error) => {
      // Don't retry on 404 (equipment not found) - it won't be found on retry
      if (error?.response?.status === 404) {
        return false;
      }
      // Retry up to 2 times for other errors
      return failureCount < 2;
    },
    // Prevent error from being thrown to ErrorBoundary
    useErrorBoundary: false,
  });

  return {
    equipment: equipment || null,
    isLoading,
    error: error ? String(error) : null,
    refetch,
  };
}
